module.exports = __webpack_public_path__ + "static/media/Group83.44ff48af.png";